import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL,
  withCredentials: true,
  headers: {
    apiKey: process.env.REACT_APP_API_KEY,
    "Content-Type": "application/json"
  },
  responseType: "json"
});

export function apiLogin(values) {
  return axiosInstance.post("usersessions/byemail", {
    ...values
  });
}

export function apiSignup(values) {
  return axiosInstance({
    method: "post",
    url: "users/byemail",
    config: {
      headers: {"Content-Type": "multipart/form-data" }
    },
    data: values
  });
}

export function apiCreateToken(data = {}) {
  return axiosInstance.post("/users/tokens", data);
}

export function apiGetCurrentSession() {
  return axiosInstance.get("usersessions/current");
}

export function apiLogout() {
  return axiosInstance.delete("usersessions/current");
}

export function apiGetUserByToken(tokenId, email) {
  return axiosInstance.get(`/users/bytoken/${tokenId}?email=${email}`);
}

export function apiPatchUserByToken(tokenId, model) {
  return axiosInstance.patch(`/users/bytoken/${tokenId}`, model);
}

export function apiUndoImpersonate() {
  return axiosInstance.post(`/usersessions/undoimpersonate`);
}
